import type { FC } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { Box, Grid } from "@mui/material"

import OrgPieCharts from "widgets/organization/pieCharts/OrgPieCharts"
import AlertsSummary from "widgets/organization/AlertsSummary"
import OrgDevices from "widgets/device/OrgDevices"
import PageTitle from "widgets/common/PageTitle"
import { selectCurrentOrgName } from "features/store/orgSlice"
import GroupsSection from "widgets/deviceGroups/GroupsSection"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"

const OrgHomepage: FC = () => {
  const { t } = useTranslation()
  const orgName = useSelector(selectCurrentOrgName)

  useDocumentTitle(orgName ? String(orgName) : t("pageTitles.HOME"))

  return (
    <>
      <PageTitle text={String(orgName)} styles={{ marginBottom: "1rem" }} />
      <Box mb={1.5}>
        <AlertsSummary />
      </Box>
      <Grid container spacing={3}>
        <OrgPieCharts />
        <GroupsSection />
        <OrgDevices />
      </Grid>
    </>
  )
}

export default OrgHomepage
